'use client';

import React from 'react';

import { RotateCcwIcon } from 'lucide-react';

import { Link } from '~/components/common/link';
import { Button } from '~/components/ui/button';

import GameResultDialog from '../../_components/game-result-dialog';
import { BreathingGameBoard } from './breathing-game-board';
import { BreathingGameSprite } from './breathing-game-sprite';

export default function BreathingGame() {
  const [gameKey, setGameKey] = React.useState(0);
  const [resultsModalOpen, setResultsModalOpen] = React.useState<boolean>(false);

  const finishGame = React.useCallback(() => {
    setTimeout(() => setResultsModalOpen(true), 400);
  }, []);

  const restartGame = React.useCallback(() => {
    setResultsModalOpen(false);
    setGameKey((key) => key + 1);
  }, []);

  return (
    <div className='sm:min-h-140 flex flex-col items-center px-8 sm:justify-center'>
      <BreathingGameBoard key={gameKey} finishGame={finishGame} />
      <GameResultDialog
        title="Good job! That's being mindful."
        open={resultsModalOpen}
        setOpen={setResultsModalOpen}
        description="Becoming aware of how you're feeling is a great way to practice self-awareness. Consider sharing your feelings with a trusted caregiver."
      >
        <div className='mt-6 flex flex-col gap-y-3'>
          <Button onClick={restartGame}>
            <RotateCcwIcon />
            Repeat Exercise
          </Button>
          <Button asChild variant='outline-secondary'>
            <Link href='/games'>Back to Games</Link>
          </Button>
        </div>
      </GameResultDialog>
      <BreathingGameSprite />
    </div>
  );
}
